export type AnalyticsConsent = 'unknown' | 'denied' | 'granted';

export const analyticsConsentEvent = 'torlin:analytics-consent-changed';
export const analyticsSettingsEvent = 'torlin:analytics-settings';

const consentCookie = 'torlin_analytics_consent';
const visitorCookie = 'torlin_analytics_visitor';
const sessionCookie = 'torlin_analytics_session';

function cookieValue(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const item = document.cookie.split('; ').find((cookie) => cookie.startsWith(`${name}=`));
  return item ? decodeURIComponent(item.slice(name.length + 1)) : null;
}

function writeCookie(name: string, value: string, maxAge: number): void {
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=${maxAge}; SameSite=Lax${secure}`;
}

function deleteCookie(name: string): void {
  document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax`;
}

export function readAnalyticsConsent(): AnalyticsConsent {
  const value = cookieValue(consentCookie);
  return value === 'granted' || value === 'denied' ? value : 'unknown';
}

export function setAnalyticsConsent(value: Exclude<AnalyticsConsent, 'unknown'>): void {
  writeCookie(consentCookie, value, 60 * 60 * 24 * 365);
  if (value === 'denied') {
    deleteCookie(visitorCookie);
    deleteCookie(sessionCookie);
  }
  window.dispatchEvent(new CustomEvent(analyticsConsentEvent));
}

export function analyticsIdentifiers(): { visitorUuid: string; sessionUuid: string } {
  let visitorUuid = cookieValue(visitorCookie);
  let sessionUuid = cookieValue(sessionCookie);
  if (!visitorUuid) {
    visitorUuid = crypto.randomUUID();
    writeCookie(visitorCookie, visitorUuid, 60 * 60 * 24 * 365);
  }
  if (!sessionUuid) sessionUuid = crypto.randomUUID();
  writeCookie(sessionCookie, sessionUuid, 60 * 30);
  return { visitorUuid, sessionUuid };
}

export function subscribeAnalyticsConsent(callback: () => void): () => void {
  window.addEventListener(analyticsConsentEvent, callback);
  return () => window.removeEventListener(analyticsConsentEvent, callback);
}
